import { gql } from "@apollo/client";

export const getDutyRequestsQuery = gql`
query GetDutyRequests($input: DutyRequestFilter!) {
  getDutyRequests(input: $input) {
    message
    response
  }
}
`;
